/** Delad katalog for header, butiksformular och produktfilter (synkad med megamenyn). */
export const NAV_CATEGORIES = [
  { 
    id: 'badrum-vvs', 
    name: 'Badrum & VVS', 
    slug: 'badrum-vvs',
    image: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=400&q=80',
    subcategories: [
      { name: 'Badrumsporslin', slug: 'badrumsporslin', image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=200&q=80' },
      { name: 'Badrumsinnredning', slug: 'badrumsinnredning', image: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=200&q=80' },
      { name: 'Blandare', slug: 'blandare', image: 'https://images.unsplash.com/photo-1585128792020-803d29415281?w=200&q=80' },
      { name: 'Badkar', slug: 'badkar', image: 'https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=200&q=80' },
      { name: 'Duscharmaturer', slug: 'duscharmaturer', image: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=200&q=80' },
      { name: 'Dusch', slug: 'dusch', image: 'https://images.unsplash.com/photo-1629079448081-f4af7794e55c?w=200&q=80' },
      { name: 'Handdukstork', slug: 'handdukstork', image: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=200&q=80' },
      { name: 'VVS', slug: 'vvs', image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=200&q=80' },
      { name: 'Badrumstillbehör', slug: 'badrumstillbehor', image: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=200&q=80' },
    ]
  },
  { 
    id: 'byggmaterial', 
    name: 'Byggmaterial, trä, fönster & dörrar', 
    slug: 'byggmaterial',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&q=80',
    subcategories: [
      { name: 'Innerväggar & innertak', slug: 'innervaggar', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&q=80' },
      { name: 'Dörrar & dörrtillbehör', slug: 'dorrar', image: 'https://images.unsplash.com/photo-1558346490-a72e53ae2d4f?w=200&q=80' },
      { name: 'Fönster & fönstertillbehör', slug: 'fonster', image: 'https://images.unsplash.com/photo-1603430416807-87dd6f9538d0?w=200&q=80' },
      { name: 'Tak', slug: 'tak', image: 'https://images.unsplash.com/photo-1632759145622-3e4e3b5d3f8a?w=200&q=80' },
      { name: 'Virke', slug: 'virke', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&q=80' },
      { name: 'Skivmaterial', slug: 'skivmaterial', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&q=80' },
      { name: 'Väggpanel & pärlspont', slug: 'panel', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&q=80' },
      { name: 'Isolering', slug: 'isolering', image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=200&q=80' },
      { name: 'Gjutning & murning', slug: 'gjutning', image: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=200&q=80' },
      { name: 'Dränering & markavlopp', slug: 'dranering', image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=200&q=80' },
      { name: 'Trappor & räcken', slug: 'trappor', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&q=80' },
    ]
  },
  { 
    id: 'el', 
    name: 'El & belysning', 
    slug: 'el',
    image: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=400&q=80',
    subcategories: [
      { name: 'Inomhusbelysning', slug: 'inomhusbelysning', image: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=200&q=80' },
      { name: 'Utomhusbelysning', slug: 'utomhusbelysning', image: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=200&q=80' },
      { name: 'Ljuskällor', slug: 'ljuskallor', image: 'https://images.unsplash.com/photo-1532007927305-aad6c94cac9c?w=200&q=80' },
      { name: 'Elinstallation', slug: 'elinstallation', image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=200&q=80' },
      { name: 'Arbetsbelysning', slug: 'arbetsbelysning', image: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=200&q=80' },
      { name: 'Hemsäkerhet', slug: 'hemsakerhet', image: 'https://images.unsplash.com/photo-1558002038-bb4237b54bed?w=200&q=80' },
      { name: 'Förlängningssladdar', slug: 'sladdar', image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=200&q=80' },
      { name: 'Elbilsladdning', slug: 'elbilsladdning', image: 'https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=200&q=80' },
    ]
  },
  { 
    id: 'farg', 
    name: 'Färg & tapeter', 
    slug: 'farg',
    image: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=400&q=80',
    subcategories: [
      { name: 'Tapeter', slug: 'tapeter', image: 'https://images.unsplash.com/photo-1618220252344-8ec99ec624b1?w=200&q=80' },
      { name: 'Inomhusfärg', slug: 'inomhusfarg', image: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=200&q=80' },
      { name: 'Utomhusfärg', slug: 'utomhusfarg', image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=200&q=80' },
      { name: 'Träskydd', slug: 'traskydd', image: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=200&q=80' },
      { name: 'Sprayburkar', slug: 'sprayburkar', image: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=200&q=80' },
      { name: 'Måleritillbehör', slug: 'maleritillbehor', image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=200&q=80' },
      { name: 'Spackel', slug: 'spackel', image: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=200&q=80' },
      { name: 'Lim & klister', slug: 'lim', image: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=200&q=80' },
    ]
  },
  { 
    id: 'golv', 
    name: 'Golv', 
    slug: 'golv',
    image: 'https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=400&q=80',
    subcategories: [
      { name: 'Parkettgolv', slug: 'parkettgolv', image: 'https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=200&q=80' },
      { name: 'Laminatgolv', slug: 'laminatgolv', image: 'https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=200&q=80' },
      { name: 'Vinylgolv', slug: 'vinylgolv', image: 'https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=200&q=80' },
      { name: 'Korkgolv', slug: 'korkgolv', image: 'https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=200&q=80' },
      { name: 'Massiva trägolv', slug: 'tragolv', image: 'https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=200&q=80' },
      { name: 'Vinylmatta', slug: 'vinylmatta', image: 'https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=200&q=80' },
      { name: 'Heltäckningsmatta', slug: 'heltackningsmatta', image: 'https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=200&q=80' },
      { name: 'Övergångslister', slug: 'overgangslister', image: 'https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=200&q=80' },
    ]
  },
  { 
    id: 'kakel', 
    name: 'Kakel & klinker', 
    slug: 'kakel',
    image: 'https://images.unsplash.com/photo-1646489553899-c4c4b5a72ccc?w=400&q=80',
    subcategories: [
      { name: 'Väggkakel', slug: 'vaggkakel', image: 'https://images.unsplash.com/photo-1646489553899-c4c4b5a72ccc?w=200&q=80' },
      { name: 'Golvklinker', slug: 'golvklinker', image: 'https://images.unsplash.com/photo-1646489553899-c4c4b5a72ccc?w=200&q=80' },
      { name: 'Mosaik', slug: 'mosaik', image: 'https://images.unsplash.com/photo-1615529328331-f8917597711f?w=200&q=80' },
      { name: 'Klinker utomhus', slug: 'klinker-utomhus', image: 'https://images.unsplash.com/photo-1646489553899-c4c4b5a72ccc?w=200&q=80' },
      { name: 'Natursten', slug: 'natursten', image: 'https://images.unsplash.com/photo-1615529328331-f8917597711f?w=200&q=80' },
      { name: 'Fogbruk & lim', slug: 'fogbruk', image: 'https://images.unsplash.com/photo-1646489553899-c4c4b5a72ccc?w=200&q=80' },
      { name: 'Kakelverktyg', slug: 'kakelverktyg', image: 'https://images.unsplash.com/photo-1646489553899-c4c4b5a72ccc?w=200&q=80' },
    ]
  },
  { 
    id: 'maskiner-verktyg', 
    name: 'Maskiner, verktyg & verkstad', 
    slug: 'maskiner-verktyg',
    image: 'https://images.unsplash.com/photo-1770763233593-74dfd0da7bf0?w=400&q=80',
    subcategories: [
      { name: 'Elverktyg', slug: 'elverktyg', image: 'https://images.unsplash.com/photo-1770763233593-74dfd0da7bf0?w=200&q=80' },
      { name: 'Handverktyg', slug: 'handverktyg', image: 'https://images.unsplash.com/photo-1581147036324-c17ac41f0e2d?w=200&q=80' },
      { name: 'Mätverktyg', slug: 'matverktyg', image: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=200&q=80' },
      { name: 'Förvaringssystem', slug: 'forvaring', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&q=80' },
      { name: 'Trädgårdsmaskiner', slug: 'tradgardsmaskiner', image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=200&q=80' },
      { name: 'Högtryckstvätt', slug: 'hogtryckstvatt', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&q=80' },
      { name: 'Verkstadsutrustning', slug: 'verkstad', image: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=200&q=80' },
      { name: 'Stegar & ställningar', slug: 'stegar', image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=200&q=80' },
    ]
  },
  { 
    id: 'tradgard', 
    name: 'Trädgård', 
    slug: 'tradgard',
    image: 'https://images.unsplash.com/photo-1711098256574-7b497260cdc9?w=400&q=80',
    subcategories: [
      { name: 'Utemöbler', slug: 'utemobler', image: 'https://images.unsplash.com/photo-1711098256574-7b497260cdc9?w=200&q=80' },
      { name: 'Grillar & utomhuskök', slug: 'grillar', image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=200&q=80' },
      { name: 'Trädgårdsredskap', slug: 'redskap', image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=200&q=80' },
      { name: 'Växter & plantering', slug: 'vaxter', image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=200&q=80' },
      { name: 'Bevattning', slug: 'bevattning', image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=200&q=80' },
      { name: 'Staket & grindar', slug: 'staket', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&q=80' },
      { name: 'Marksten & plattor', slug: 'marksten', image: 'https://images.unsplash.com/photo-1615529328331-f8917597711f?w=200&q=80' },
      { name: 'Pool & spa', slug: 'pool', image: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=200&q=80' },
    ]
  },
  { 
    id: 'varme', 
    name: 'Värme & ventilation', 
    slug: 'varme',
    image: 'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=400&q=80',
    subcategories: [
      { name: 'Värmepumpar', slug: 'varmepumpar', image: 'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=200&q=80' },
      { name: 'Element & radiatorer', slug: 'element', image: 'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=200&q=80' },
      { name: 'Golvvärme', slug: 'golvvarme', image: 'https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=200&q=80' },
      { name: 'Kaminer & eldstäder', slug: 'kaminer', image: 'https://images.unsplash.com/photo-1544009025-5aceeabac544?w=200&q=80' },
      { name: 'Ventilation', slug: 'ventilation', image: 'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=200&q=80' },
      { name: 'Luftkonditionering', slug: 'luftkonditionering', image: 'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=200&q=80' },
      { name: 'Avfuktare', slug: 'avfuktare', image: 'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=200&q=80' },
    ]
  },
  { 
    id: 'smarta-hem', 
    name: 'Smarta Hem', 
    slug: 'smarta-hem',
    image: 'https://images.unsplash.com/photo-1752262167753-37a0ec83f614?w=400&q=80',
    subcategories: [
      { name: 'Smart belysning', slug: 'smart-belysning', image: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=200&q=80' },
      { name: 'Smarta lås', slug: 'smarta-las', image: 'https://images.unsplash.com/photo-1558002038-bb4237b54bed?w=200&q=80' },
      { name: 'Övervakningskameror', slug: 'kameror', image: 'https://images.unsplash.com/photo-1558002038-bb4237b54bed?w=200&q=80' },
      { name: 'Smarta termostater', slug: 'termostater', image: 'https://images.unsplash.com/photo-1752262167753-37a0ec83f614?w=200&q=80' },
      { name: 'Smarta högtalare', slug: 'hogtalare', image: 'https://images.unsplash.com/photo-1752262167753-37a0ec83f614?w=200&q=80' },
      { name: 'Smarta sensorer', slug: 'sensorer', image: 'https://images.unsplash.com/photo-1752262167753-37a0ec83f614?w=200&q=80' },
    ]
  },
  {
    id: 'arbetsklader',
    name: 'Arbetskläder',
    slug: 'arbetsklader',
    image: 'https://images.unsplash.com/photo-1584464491033-06628f3a6b7b?w=400&q=80',
    subcategories: [
      { name: 'Jackor', slug: 'arbetsklader-jackor', image: 'https://images.unsplash.com/photo-1544022613-e87ca75a784a?w=200&q=80' },
      { name: 'Byxor', slug: 'arbetsklader-byxor', image: 'https://images.unsplash.com/photo-1473966968600-fa801b869a1a?w=200&q=80' },
      { name: 'Shorts', slug: 'arbetsklader-shorts', image: 'https://images.unsplash.com/photo-1591195853828-11db59a44f6b?w=200&q=80' },
      { name: 'Tröjor', slug: 'arbetsklader-trojor', image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=200&q=80' },
      { name: 'Regnkläder', slug: 'arbetsklader-regnklader', image: 'https://images.unsplash.com/photo-1433863440390-0be955e3aa23?w=200&q=80' },
      { name: 'Hi-Vis', slug: 'arbetsklader-hi-vis', image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=200&q=80' },
    ]
  },
  {
    id: 'arbetsskor',
    name: 'Arbetsskor',
    slug: 'arbetsskor',
    image: 'https://images.unsplash.com/photo-1612817288484-6f916006741a?w=400&q=80',
    subcategories: [
      { name: 'Skyddsskor', slug: 'arbetsskor-skyddsskor', image: 'https://images.unsplash.com/photo-1549298916-b41d501d3772?w=200&q=80' },
      { name: 'Stövlar', slug: 'arbetsskor-stovlar', image: 'https://images.unsplash.com/photo-1608256246200-53e635b5b65f?w=200&q=80' },
      { name: 'Sandaler', slug: 'arbetsskor-sandaler', image: 'https://images.unsplash.com/photo-1603487742131-4160ec999306?w=200&q=80' },
    ]
  },
  {
    id: 'skyddsutrustning',
    name: 'Skyddsutrustning',
    slug: 'skyddsutrustning',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400&q=80',
    subcategories: [
      { name: 'Handskar', slug: 'skydds-handskar', image: 'https://images.unsplash.com/photo-1584225064785-c62a40b12144?w=200&q=80' },
      { name: 'Hjälmar', slug: 'skydds-hjalmar', image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=200&q=80' },
      { name: 'Hörselskydd', slug: 'skydds-horselskydd', image: 'https://images.unsplash.com/photo-1598480366431-7c964a50fc31?w=200&q=80' },
      { name: 'Knäskydd', slug: 'skydds-knaskydd', image: 'https://images.unsplash.com/photo-1584464491033-06628f3a6b7b?w=200&q=80' },
      { name: 'Glasögon', slug: 'skydds-glasogon', image: 'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?w=200&q=80' },
    ]
  },
];

export function getSubcategoriesForParent(parentId) {
  const cat = NAV_CATEGORIES.find((c) => c.id === parentId);
  return cat?.subcategories ?? [];
}

export function findSubcategoryLabel(parentId, subSlug) {
  if (!subSlug) return '';
  const sub = getSubcategoriesForParent(parentId).find((x) => x.slug === subSlug);
  return sub?.name ?? subSlug;
}
